import { useState } from 'react';
import { Box, InputAdornment } from '@mui/material';
import { InputTextField } from './InputStandard';
import { osirisTokens } from '@/theme/tokens';
import type { ComponentProps } from 'react';

type InputProps = ComponentProps<typeof InputTextField>;

export type PasswordFieldProps = Omit<InputProps, 'type'>;

export function PasswordField({ slotProps, ...props }: PasswordFieldProps) {
  const [show, setShow] = useState(false);

  const externalInputSlot =
    (slotProps as { input?: Record<string, unknown> } | undefined)?.input ?? {};

  return (
    <InputTextField
      {...props}
      type={show ? 'text' : 'password'}
      slotProps={{
        ...slotProps,
        input: {
          ...externalInputSlot,
          endAdornment: (
            <InputAdornment position="end">
              <Box
                component="button"
                type="button"
                onClick={() => setShow((v) => !v)}
                tabIndex={-1}
                aria-label={show ? 'Hide password' : 'Show password'}
                className="password-toggle"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1,
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  color: show ? osirisTokens.text.active : osirisTokens.text.muted,
                  fontFamily: osirisTokens.fonts.display,
                  fontSize: 14,
                  letterSpacing: '0.06em',
                  textTransform: 'lowercase',
                  transition: 'color 120ms ease',
                  '&:hover': { color: osirisTokens.text.active },
                }}
              >
                {show ? 'hide' : 'show'}
              </Box>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}

PasswordField.displayName = 'PasswordField';
